import {Pipe, PipeTransform} from '@angular/core';
import {Select} from '@wba-ui-module/components/formfields/select/select';

@Pipe({
    name: 'selectItem',
    standalone: false
})
export class SelectItemPipe implements PipeTransform {
  transform(items: Partial<{ id, name }>[], valueKey: string, labelKey: string, additionalLabelKey?: string): Select[] {
    if (items === null) {
      return null;
    }
    return items.map(i => ({value: i[valueKey], label: i[labelKey] + (i[additionalLabelKey] ? ' (' + i[additionalLabelKey] + ')' : '')}));
  }
}
